import React from "react"
import Container from "../Container"
import home_hero from "../../images/home/hero/home_hero.png"
import home_hero_small from "../../images/home/hero/home_hero_small.png"

function HomeHero() {
  return (
    <Container>
      <div className="flex flex-col lg:flex-row justify-between mt-32 mb-10 py-10 px-2">
        <p className="text-[32px] w-[80%] lg:text-[64px] lg:w-[800px] mb-[36px] font-[700] leading-[34px] lg:leading-[68px]">
          YOUR TRUSTED ROOFING EXPERTS
        </p>
        <p className="text-[12px] lg:text-[16px] w-[500px]  font-[400] text-[#222222] leading-[24px]">
          Your roof is crucial for safeguarding your home and loved ones. With
          years of experience and a dedicated team, we provide top-quality
          roofing solutions that last.
        </p>
      </div>
      <div className="aspect-[1200/573] border rounded-[20px]">
        <img className="w-full hidden md:block" src={home_hero} alt="" />
        <img className="w-full md:hidden " src={home_hero_small} alt="" />
      </div>
    </Container>
  )
}

export default HomeHero
